// HELM client <-> gateway protocol: shared enums (SPEC §7, §8, §9).
//
// Conventions (SPEC §7.3): prices are integer ticks (sint64), money is signed integer cents
// (sint64), timestamps are exchange time in nanoseconds since the Unix epoch (fixed64).
// Enum value 0 is always UNSPECIFIED so an omitted field can never be mistaken for a real value.

// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=none"
// @generated from file helm/v1/common.proto (package helm.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file helm/v1/common.proto.
 */
export const file_helm_v1_common: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from enum helm.v1.Side
 */
export enum Side {
  /**
   * @generated from enum value: SIDE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SIDE_BUY = 1;
   */
  BUY = 1,

  /**
   * @generated from enum value: SIDE_SELL = 2;
   */
  SELL = 2,
}

/**
 * Describes the enum helm.v1.Side.
 */
export const SideSchema: GenEnum<Side> = /*@__PURE__*/
  enumDesc(file_helm_v1_common, 0);

/**
 * @generated from enum helm.v1.OrderType
 */
export enum OrderType {
  /**
   * @generated from enum value: ORDER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ORDER_TYPE_MARKET = 1;
   */
  MARKET = 1,

  /**
   * @generated from enum value: ORDER_TYPE_LIMIT = 2;
   */
  LIMIT = 2,

  /**
   * @generated from enum value: ORDER_TYPE_STOP_MARKET = 3;
   */
  STOP_MARKET = 3,

  /**
   * @generated from enum value: ORDER_TYPE_STOP_LIMIT = 4;
   */
  STOP_LIMIT = 4,

  /**
   * @generated from enum value: ORDER_TYPE_TRAILING_STOP = 5;
   */
  TRAILING_STOP = 5,

  /**
   * @generated from enum value: ORDER_TYPE_MIT = 6;
   */
  MIT = 6,
}

/**
 * Describes the enum helm.v1.OrderType.
 */
export const OrderTypeSchema: GenEnum<OrderType> = /*@__PURE__*/
  enumDesc(file_helm_v1_common, 1);

/**
 * @generated from enum helm.v1.Tif
 */
export enum Tif {
  /**
   * @generated from enum value: TIF_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TIF_DAY = 1;
   */
  DAY = 1,

  /**
   * @generated from enum value: TIF_GTC = 2;
   */
  GTC = 2,

  /**
   * @generated from enum value: TIF_IOC = 3;
   */
  IOC = 3,

  /**
   * @generated from enum value: TIF_FOK = 4;
   */
  FOK = 4,
}

/**
 * Describes the enum helm.v1.Tif.
 */
export const TifSchema: GenEnum<Tif> = /*@__PURE__*/
  enumDesc(file_helm_v1_common, 2);

/**
 * Where an order came from (SPEC §7.3, §9.9 step 0). Drives manual_or_auto tagging (§6.9).
 *
 * @generated from enum helm.v1.Origin
 */
export enum Origin {
  /**
   * @generated from enum value: ORIGIN_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ORIGIN_DOM = 1;
   */
  DOM = 1,

  /**
   * @generated from enum value: ORIGIN_CHART = 2;
   */
  CHART = 2,

  /**
   * @generated from enum value: ORIGIN_TICKET = 3;
   */
  TICKET = 3,

  /**
   * @generated from enum value: ORIGIN_SCALP_PAD = 4;
   */
  SCALP_PAD = 4,

  /**
   * @generated from enum value: ORIGIN_HOTKEY = 5;
   */
  HOTKEY = 5,

  /**
   * @generated from enum value: ORIGIN_COPY = 6;
   */
  COPY = 6,

  /**
   * @generated from enum value: ORIGIN_RISK = 7;
   */
  RISK = 7,

  /**
   * @generated from enum value: ORIGIN_STRATEGY = 8;
   */
  STRATEGY = 8,

  /**
   * @generated from enum value: ORIGIN_API = 9;
   */
  API = 9,

  /**
   * a per-entry bracket child placed by the gateway (AUTO; never copied)
   *
   * @generated from enum value: ORIGIN_BRACKET = 10;
   */
  BRACKET = 10,
}

/**
 * Describes the enum helm.v1.Origin.
 */
export const OriginSchema: GenEnum<Origin> = /*@__PURE__*/
  enumDesc(file_helm_v1_common, 3);

/**
 * Order lifecycle (SPEC §6.10 state machine).
 *
 * @generated from enum helm.v1.OrderState
 */
export enum OrderState {
  /**
   * @generated from enum value: ORDER_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ORDER_STATE_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * @generated from enum value: ORDER_STATE_PENDING_SUBMIT = 2;
   */
  PENDING_SUBMIT = 2,

  /**
   * @generated from enum value: ORDER_STATE_WORKING = 3;
   */
  WORKING = 3,

  /**
   * @generated from enum value: ORDER_STATE_PARTIALLY_FILLED = 4;
   */
  PARTIALLY_FILLED = 4,

  /**
   * @generated from enum value: ORDER_STATE_FILLED = 5;
   */
  FILLED = 5,

  /**
   * @generated from enum value: ORDER_STATE_PENDING_CANCEL = 6;
   */
  PENDING_CANCEL = 6,

  /**
   * @generated from enum value: ORDER_STATE_CANCELLED = 7;
   */
  CANCELLED = 7,

  /**
   * @generated from enum value: ORDER_STATE_PENDING_MODIFY = 8;
   */
  PENDING_MODIFY = 8,

  /**
   * @generated from enum value: ORDER_STATE_REJECTED = 9;
   */
  REJECTED = 9,

  /**
   * @generated from enum value: ORDER_STATE_TRIGGERED = 10;
   */
  TRIGGERED = 10,

  /**
   * @generated from enum value: ORDER_STATE_UNKNOWN = 11;
   */
  UNKNOWN = 11,

  /**
   * @generated from enum value: ORDER_STATE_NOT_PLACED = 12;
   */
  NOT_PLACED = 12,
}

/**
 * Describes the enum helm.v1.OrderState.
 */
export const OrderStateSchema: GenEnum<OrderState> = /*@__PURE__*/
  enumDesc(file_helm_v1_common, 4);

/**
 * @generated from enum helm.v1.BracketRole
 */
export enum BracketRole {
  /**
   * @generated from enum value: BRACKET_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BRACKET_ROLE_ENTRY = 1;
   */
  ENTRY = 1,

  /**
   * @generated from enum value: BRACKET_ROLE_TARGET = 2;
   */
  TARGET = 2,

  /**
   * @generated from enum value: BRACKET_ROLE_STOP = 3;
   */
  STOP = 3,
}

/**
 * Describes the enum helm.v1.BracketRole.
 */
export const BracketRoleSchema: GenEnum<BracketRole> = /*@__PURE__*/
  enumDesc(file_helm_v1_common, 5);

/**
 * Risk status per account (SPEC §10.5).
 *
 * @generated from enum helm.v1.RiskStatus
 */
export enum RiskStatus {
  /**
   * @generated from enum value: RISK_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RISK_STATUS_OK = 1;
   */
  OK = 1,

  /**
   * @generated from enum value: RISK_STATUS_WARN = 2;
   */
  WARN = 2,

  /**
   * @generated from enum value: RISK_STATUS_DANGER = 3;
   */
  DANGER = 3,

  /**
   * @generated from enum value: RISK_STATUS_BREACHED = 4;
   */
  BREACHED = 4,

  /**
   * @generated from enum value: RISK_STATUS_LOCKED = 5;
   */
  LOCKED = 5,

  /**
   * @generated from enum value: RISK_STATUS_FIRM_BREACHED = 6;
   */
  FIRM_BREACHED = 6,
}

/**
 * Describes the enum helm.v1.RiskStatus.
 */
export const RiskStatusSchema: GenEnum<RiskStatus> = /*@__PURE__*/
  enumDesc(file_helm_v1_common, 6);

/**
 * Per-plant connection state (SPEC §6.12, §17.2 status bar dots).
 *
 * @generated from enum helm.v1.PlantState
 */
export enum PlantState {
  /**
   * @generated from enum value: PLANT_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLANT_STATE_DOWN = 1;
   */
  DOWN = 1,

  /**
   * @generated from enum value: PLANT_STATE_DEGRADED = 2;
   */
  DEGRADED = 2,

  /**
   * @generated from enum value: PLANT_STATE_UP = 3;
   */
  UP = 3,

  /**
   * dropped; the gateway is logging it in again (backoff)
   *
   * @generated from enum value: PLANT_STATE_RECONNECTING = 4;
   */
  RECONNECTING = 4,
}

/**
 * Describes the enum helm.v1.PlantState.
 */
export const PlantStateSchema: GenEnum<PlantState> = /*@__PURE__*/
  enumDesc(file_helm_v1_common, 7);

/**
 * Whole-session state (SPEC §6.4, §6.10). Order entry is enabled only in READY.
 *
 * @generated from enum helm.v1.SessionStatus
 */
export enum SessionStatus {
  /**
   * @generated from enum value: SESSION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SESSION_STATUS_DISCONNECTED = 1;
   */
  DISCONNECTED = 1,

  /**
   * @generated from enum value: SESSION_STATUS_CONNECTING = 2;
   */
  CONNECTING = 2,

  /**
   * @generated from enum value: SESSION_STATUS_SYNCING = 3;
   */
  SYNCING = 3,

  /**
   * @generated from enum value: SESSION_STATUS_READY = 4;
   */
  READY = 4,

  /**
   * @generated from enum value: SESSION_STATUS_DEGRADED = 5;
   */
  DEGRADED = 5,

  /**
   * @generated from enum value: SESSION_STATUS_KICKED = 6;
   */
  KICKED = 6,
}

/**
 * Describes the enum helm.v1.SessionStatus.
 */
export const SessionStatusSchema: GenEnum<SessionStatus> = /*@__PURE__*/
  enumDesc(file_helm_v1_common, 8);

/**
 * Where a session's order plant routes orders (ADR-0010, ADR-0021). Always set by the gateway from
 * its environment guard's classification of the order-plant URL and system name, never from client
 * input. The guard admits only MOCK (a loopback host) and TEST (RITHMIC_TEST_URL, "Rithmic Test"),
 * so this gateway never reports PAPER or LIVE; clients enable order entry only for MOCK and TEST.
 *
 * @generated from enum helm.v1.TradingEnvironment
 */
export enum TradingEnvironment {
  /**
   * unknown / no order plant: never tradable
   *
   * @generated from enum value: TRADING_ENVIRONMENT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * the local rithmic-mock (loopback)
   *
   * @generated from enum value: TRADING_ENVIRONMENT_MOCK = 1;
   */
  MOCK = 1,

  /**
   * Rithmic Test
   *
   * @generated from enum value: TRADING_ENVIRONMENT_TEST = 2;
   */
  TEST = 2,

  /**
   * paper / prop-firm system: tradable only with the login's switch on (ADR-0027)
   *
   * @generated from enum value: TRADING_ENVIRONMENT_PAPER = 3;
   */
  PAPER = 3,

  /**
   * Rithmic 01 / live: tradable only with the login's switch on (ADR-0027)
   *
   * @generated from enum value: TRADING_ENVIRONMENT_LIVE = 4;
   */
  LIVE = 4,
}

/**
 * Describes the enum helm.v1.TradingEnvironment.
 */
export const TradingEnvironmentSchema: GenEnum<TradingEnvironment> = /*@__PURE__*/
  enumDesc(file_helm_v1_common, 9);

/**
 * A Rithmic login connection's state (ADR-0027).
 *
 * @generated from enum helm.v1.LoginConnState
 */
export enum LoginConnState {
  /**
   * @generated from enum value: LOGIN_CONN_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LOGIN_CONN_STATE_DISCONNECTED = 1;
   */
  DISCONNECTED = 1,

  /**
   * @generated from enum value: LOGIN_CONN_STATE_CONNECTING = 2;
   */
  CONNECTING = 2,

  /**
   * @generated from enum value: LOGIN_CONN_STATE_CONNECTED = 3;
   */
  CONNECTED = 3,

  /**
   * Rithmic refused the login: detail has its rp_code text; LoginStatus.retry says whether it is tried again
   *
   * @generated from enum value: LOGIN_CONN_STATE_REJECTED = 4;
   */
  REJECTED = 4,

  /**
   * ForcedLogout: used elsewhere; manual reconnect only
   *
   * @generated from enum value: LOGIN_CONN_STATE_KICKED = 5;
   */
  KICKED = 5,
}

/**
 * Describes the enum helm.v1.LoginConnState.
 */
export const LoginConnStateSchema: GenEnum<LoginConnState> = /*@__PURE__*/
  enumDesc(file_helm_v1_common, 10);

/**
 * What the gateway does about a refused login (LoginStatus.retry; owner decision 2026-10-04): a
 * transient refusal is tried again by itself, at most 5 tries in all over about 5 minutes.
 *
 * @generated from enum helm.v1.LoginRetryState
 */
export enum LoginRetryState {
  /**
   * nothing to retry (connected, connecting, never refused)
   *
   * @generated from enum value: LOGIN_RETRY_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * the next try is scheduled at LoginRetry.next_at_ms
   *
   * @generated from enum value: LOGIN_RETRY_STATE_RETRYING = 1;
   */
  RETRYING = 1,

  /**
   * every try was refused: waits for the user
   *
   * @generated from enum value: LOGIN_RETRY_STATE_GAVE_UP = 2;
   */
  GAVE_UP = 2,

  /**
   * never tried again by itself (LoginRetry.why)
   *
   * @generated from enum value: LOGIN_RETRY_STATE_NOT_RETRIED = 3;
   */
  NOT_RETRIED = 3,

  /**
   * the user stopped retrying
   *
   * @generated from enum value: LOGIN_RETRY_STATE_STOPPED = 4;
   */
  STOPPED = 4,
}

/**
 * Describes the enum helm.v1.LoginRetryState.
 */
export const LoginRetryStateSchema: GenEnum<LoginRetryState> = /*@__PURE__*/
  enumDesc(file_helm_v1_common, 11);

/**
 * @generated from enum helm.v1.NoticeLevel
 */
export enum NoticeLevel {
  /**
   * @generated from enum value: NOTICE_LEVEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTICE_LEVEL_INFO = 1;
   */
  INFO = 1,

  /**
   * @generated from enum value: NOTICE_LEVEL_WARN = 2;
   */
  WARN = 2,

  /**
   * @generated from enum value: NOTICE_LEVEL_ERROR = 3;
   */
  ERROR = 3,
}

/**
 * Describes the enum helm.v1.NoticeLevel.
 */
export const NoticeLevelSchema: GenEnum<NoticeLevel> = /*@__PURE__*/
  enumDesc(file_helm_v1_common, 12);

